import React from "react";

import { BrandLogo } from "icons";

import { Button, Typography } from "clearsense-ui/components";

import { FOOTER_NAVIGATION } from "./constants";

const Footer = ({ showCTA = false }) => (
  <div>
    {showCTA && (
      <div className="footer-cta">
        <Typography style="jumbo" className="font-serif text-center text-white">
          <span className="block">Welcome to the future</span>
          <span className="block">of data-driven healthcare.</span>
        </Typography>
        <Button
          className="mt-10 rounded-full"
          href="#"
          label="Contact Us"
          style="secondary"
        ></Button>
      </div>
    )}
    <div className="border footer-links-section">
      <div className="flex flex-col w-1/3 gap-2 p-10 mt-8">
        <BrandLogo />
        <Typography className="mt-10" style="large">
          Convert your data into a single source of truth to accelerate data
          maturity, optimize analytics tools, improve decision quality and
          unlock meaningful outcomes.
        </Typography>
      </div>
      <div className="w-1/3 p-10">
        <Typography style="h3" className="mt-5 font-serif font-bold">
          Featured Links
        </Typography>
        <div className="flex gap-10 pt-5">
          <ul role="list" className="mt-4 space-y-7">
            {FOOTER_NAVIGATION.links.slice(0, 4).map(item => (
              <li key={item.name}>
                <Typography style="h4">
                  <a
                    href={item.href}
                    className="text-lg font-medium hover:text-gray-900"
                  >
                    {item.name}
                  </a>
                </Typography>
              </li>
            ))}
          </ul>
          <ul role="list" className="mt-4 space-y-7">
            {FOOTER_NAVIGATION.links.slice(-4).map(item => (
              <li key={item.name}>
                <Typography style="h4">
                  <a
                    href={item.href}
                    className="text-lg font-medium hover:text-gray-900"
                  >
                    {item.name}
                  </a>
                </Typography>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="w-1/3 p-10 ">
        <Typography style="h3" className="mt-5 ml-8 font-serif font-bold">
          Connect with us
        </Typography>
        <div className="flex pl-10 mt-10 space-x-6 md:order-2">
          {FOOTER_NAVIGATION.social.map(item => (
            <a
              key={item.name}
              href={item.href}
              className="text-blue-400 hover:text-blue-900"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="w-6 h-6" aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="footer">
      <Typography className="mr-2 font-bold">
        EMPOWER DATA CONFIDENCE
      </Typography>
      <Typography>© Clearsense 2022. All rights reserved.</Typography>
    </div>
  </div>
);

export default Footer;
